import React from "react";
import { Helmet } from "react-helmet";
import { formatBrandInText } from "../transformers/BrandText";

const MetaTags = ({
  meta = {},
  title = "",
  tags = [],
  canonicalUri,
  structuredData
}) => {
  // eslint-disable-next-line no-undef
  if (!__BROWSER__) return "";

  const metaAttributes =
    tags &&
    tags.map(tag =>
      tag.properties.reduce((data, instance) => {
        data[instance.key] = (instance.key === 'content') ? formatBrandInText(instance.value) : instance.value;
        return data;
      }, {})
    );

  if (structuredData) {
    structuredData.map(sData => {
      if (typeof sData.name !== 'undefined') {
        sData.name = formatBrandInText(sData.name)
      }
    })
  }

  return (
    <Helmet>
      <title>{formatBrandInText(meta.title ? meta.title : title)}</title>

      {metaAttributes &&
        metaAttributes.map((attributes, index) => {
          return <meta key={`meta${index}`} {...attributes} />;
        })}

      <meta name="apple-mobile-web-app-capable" content="yes" />

      {canonicalUri && (
        <link
          itemProp="url"
          rel="canonical"
          href={`https://www.carparts.com${canonicalUri}`}
        />
      )}
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredData)
          }}
        />
      )}
    </Helmet>
  );
};

export default MetaTags;
